<template>
    <v-tooltip top>
        <template #activator="data">
        <i slot="activator" :class="iconClass" pr-2 :style='`color:${iconColor}`'></i>                                        
        </template>
        <span v-html="text"></span>
    </v-tooltip>  
</template>

<script>
    export default {
        props: {
            iconColor:{
                type:String,
                default:"#37C6F2"
            },
            iconClass:{
                type:String,
                default:"fas fa-question-circle"
            },
            text: {
                type:String
            }
        }
    }
</script>

<style scoped>

</style>